import { render, staticRenderFns } from "./follower.vue?vue&type=template&id=56bbf1be&scoped=true"
import script from "./follower.vue?vue&type=script&lang=js"
export * from "./follower.vue?vue&type=script&lang=js"
import style0 from "./follower.vue?vue&type=style&index=0&id=56bbf1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbf1be",
  null
  
)

export default component.exports